import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Message } from '../../types';

interface MessagesState {
  byConversation: Record<string, Message[]>;
  loading: boolean;
  error: string | null;
}

const initialState: MessagesState = {
  byConversation: {},
  loading: false,
  error: null,
};

const messagesSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMessages: (state, action: PayloadAction<{ conversationId: string; messages: Message[] }>) => {
      state.byConversation[action.payload.conversationId] = action.payload.messages;
      state.loading = false;
    },
    addMessage: (state, action: PayloadAction<Message>) => {
      const conversationId = action.payload.conversation_id;
      if (!state.byConversation[conversationId]) {
        state.byConversation[conversationId] = [];
      }
      state.byConversation[conversationId].push(action.payload);
    },
    updateMessage: (state, action: PayloadAction<Message>) => {
      const conversationId = action.payload.conversation_id;
      const messages = state.byConversation[conversationId];
      if (messages) {
        const index = messages.findIndex(m => m.id === action.payload.id);
        if (index !== -1) {
          messages[index] = action.payload;
        }
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setLoading, setMessages, addMessage, updateMessage, setError } = messagesSlice.actions;
export default messagesSlice.reducer; 